import { GlobalStyles } from '@mui/material';

const CustomGlobalStyles = () => {
  return (
    <GlobalStyles
    styles={{
      '*': {
        scrollbarWidth: 'thin',
        scrollbarColor: 'grey transparent', 
      },
      '*::-webkit-scrollbar': {
        width: '6px',
        height: '6px',
      },
      '*::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'grey',
        borderRadius: '4px',
      },
      '*::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'darkgrey',
      },
    }}
  />
  )
}

export default CustomGlobalStyles;